<template>
  <div class="parts-grid-wrapper" :style="getStyle_PartsGridWrapper()">
    <table class="part-list-table theme-fontname" v-if="project.hotspots !== null">
      <div v-if="project.uxd.hidedetailstray == '1'">
        <DetailsTable parentComponent="PartsGrid"></DetailsTable>
      </div>
      <div v-else>
        <thead>
          <tr class="theme-tabfontcolor">
            <th v-for="val in project.gridColumns" :key="val.key">{{val.displayName}}</th>
          </tr>
        </thead>
        <tbody ref="tableBody" class="part-list-table-body">
          <tr v-bind:key="gr.index"
                v-for="gr in project.gridRows.filter(x => x.twin === -1)"
                :class="highlightGridRow(gr.id === selectedHotspotId, gr.key)"
                :id="'hsit' + gr.id">
                <td v-bind:key="val.id" v-for="val in gr.values" @click="doSelectHotspot(gr.id)" v-bind:class="{'nowrap': val.column == 'article' || val.column == 'oem'}">
                    <template v-if="val.column !== '' && val.column !== '_assy' && val.column !== '_ecat'">
                        {{val.value}}
                    </template>
                    <template v-if="val.column === '' && val.value !== ''">
                        <a :href="val.value" :target="val.context" :title="val.purpose">
                            <img :src="displayHyperlinkIcon(val.icon)" />
                        </a>
                    </template>
                    <template v-if="val.column === '_assy' && val.value !== ''">
                      <v-icon @click="showDrawingById(gr.link)"
                              :title="project.drawingMap[gr.link].name"
                              :style="'color:' + project.uxd.assylinkcolor">
                              {{project.uxd.assylink}}
                      </v-icon>
                    </template>
                    <template v-if="val.column === '_ecat' && val.value !== ''">
                      <v-icon @click="selectPartById(gr.link)"
                              :title="project.parts.find(x => x.id === gr.link).data.name"
                              :style="'color:' + project.uxd.ecatlinkcolor">
                              {{project.uxd.ecatlink}}
                      </v-icon>
                    </template>
                </td>
              </tr>
            </tbody>
          </div>
        </table>
    </div>
</template>

<script>
    import {mapActions, mapState, mapGetters} from 'vuex'
    import DetailsTable from "./DetailsTable.vue";

    export default {
        name: 'PartsGrid',
        data() {
            return {
                windowWidth: window.innerWidth,
                msg: ''
            }
        },
        computed: {
            ...mapState([
                'project'
            ]),
            ...mapGetters([
                'selectedHotspotId'
            ])
        },
        components: {
            DetailsTable
        },
        methods: {
            ...mapActions([
                'selectHotspot',
                'showDrawingById',
                'selectPartById',
                'closeLeftPane',
                'addToCart'
            ]),
            highlightGridRow(selected, funcId) {
              if(selected) return "theme-highlightcolor";
              if(this.project.uxd.ordercontext != "_script" && this.project.uxd.quotecontext != "_script") return "";
              let checked = JSON.parse(sessionStorage.getItem("orderscriptcalls") || "[]").concat(JSON.parse(sessionStorage.getItem("quotescriptcalls") || "[]"));
              if(checked.length == 0) return "";
              return checked.includes(funcId) ? "theme-checkedhighlightcolor" : "";
            },
            doSelectHotspot(hotspotId) {
                this.$store.commit('updatePanAndZoomOnHotspotSelection', true);
                if (this.windowWidth < 1050) {
                    this.closeLeftPane();
                }
                this.selectHotspot({hotspotId: hotspotId, specificFunc : -1});
            },
            updateSelectedHotspotVisibility() {

            },
            displayHyperlinkIcon(id) {
                return this.project.baseurl + 'getLinkIcon.php?token=' + this.project.token + '&id=' + id
            },
            onResize() {
                this.windowWidth = window.innerWidth
            },
            getHotspotFuncs() {
              // eslint-disable-next-line no-console
              let funcs = [];
              for(let h of this.project.hotspotsData.hotspots)
                for(let f of h.func)
                  funcs.push(f);
              return funcs;
            },
            addToCartPG(func) {
                // User clicked Order or Quote icon. Let projects.js handle it
                this.project.orderColumnValue = '';
                this.addToCart(func);
            },
            displayCustomIcon(func) {
              if(func.linktype == "O") {
                if(this.project.uxd.customordericon == "0") return undefined;
                return "https://data.spareparts.live/assets/styles/cta_order_" + this.project.uxd.domainid + ".png?" + new Date().getTime();
              } else if(func.linktype == "Q") {
                if(this.project.uxd.customquoteicon == "0") return undefined;
                return "https://data.spareparts.live/assets/styles/cta_quote_" + this.project.uxd.domainid + ".png?" + new Date().getTime();
              }
              else return undefined;
            },

            displayIcon(func) {
              if (func.linktype == "O") return this.project.uxd.shopicon;
              if (func.linktype === 'Q') return this.project.uxd.quoteicon
              return undefined;
            },
            displayScriptExecuted(func) {
              let cookie = func.linktype === 'O' ? 'orderscriptcalls' : 'quotescriptcalls';
              let context = func.linktype === 'O' ? this.project.uxd.ordercontext : this.project.uxd.quotecontext;
              if(context == "_script" || context == "_email") {
                let osc = JSON.parse(sessionStorage.getItem(cookie) || "[]");
                return osc.includes(func.id);
              } else {
                sessionStorage.removeItem(cookie);
                return false;
              }
            },
            displayScriptMouseover(func) {
              let cookie = func.linktype === 'O' ? 'orderscriptcalls' : 'quotescriptcalls';
              let context = func.linktype === 'O' ? this.project.uxd.ordercontext : this.project.uxd.quotecontext;
              let title = func.linktype === 'O' ? this.project.uxd.hovertriggeredorder : this.project.uxd.hovertriggeredquote;
              if(context == "_script" || context == "_email") {
                let osc = JSON.parse(sessionStorage.getItem(cookie) || "[]");
                return osc.includes(func.id) ? title : '';
              } else {
                return '';
              }
            },
            getStyle_PartsGridWrapper() {
              if(this.project.uxd.hideheader == '1')
                return 'height:calc(100vh - 265px)';
              else
                return 'height:calc(100vh - 400px)';
            },



        },
        mounted: function () {
            this.$store.watch(() => this.$store.getters.selectedHotspotId, this.updateSelectedHotspotVisibility);
            this.$nextTick(() => {
                window.addEventListener('resize', this.onResize);
            })
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.onResize);
        }
    }
</script>
